export const DECA_CONSULTA_SOLICITACAO_GET =
  "deca.DECA_CONSULTA_SOLICITACAO_GET";
